/**
 * Order Sources API Mutations
 *
 * Create + update + state-transition (activate/deactivate) operations.
 */

import { apiClient } from '../client';

import type {
  CreateOrderSourcePayload,
  OrderSource,
  UpdateOrderSourcePayload,
} from './types';

export async function createOrderSource(
  payload: CreateOrderSourcePayload,
): Promise<OrderSource> {
  const response = await apiClient.post<{ order_source: OrderSource }>(
    '/api/order_sources',
    { order_source: payload },
  );
  return response.data.order_source;
}

export async function updateOrderSource(
  id: number,
  payload: UpdateOrderSourcePayload,
): Promise<OrderSource> {
  const response = await apiClient.patch<{ order_source: OrderSource }>(
    `/api/order_sources/${id}`,
    { order_source: payload },
  );
  return response.data.order_source;
}

export async function activateOrderSource(id: number): Promise<OrderSource> {
  const response = await apiClient.post<{ order_source: OrderSource }>(
    `/api/order_sources/${id}/activate`,
  );
  return response.data.order_source;
}

export async function deactivateOrderSource(id: number): Promise<OrderSource> {
  const response = await apiClient.post<{ order_source: OrderSource }>(
    `/api/order_sources/${id}/deactivate`,
  );
  return response.data.order_source;
}
